<template>
	<div class="line">
		<div class="bg1"></div>
    <div class="bg2"></div>
	<div class="textPosition" v-if="defaultdata && defaultdata.length > 1">
      <div class="left-text">
        <div class="lt-1">{{ defaultdata[0].value2 }}张</div>
        <div class="hengg">
          <div class="hengg2"></div>
        </div>
        <div class="lt-2">{{ defaultdata[0].value1 }}</div>
        <div class="lt-3">{{ (+defaultdata[0].value2 / total * 100).toFixed(2) }}%</div>
      </div>
      <div class="right-text">
        <div class="rt-1">{{ defaultdata[1].value2 }}张</div>
        <div class="henggr">
          <div class="henggr2"></div>
        </div>
        <div class="rt-2">{{ defaultdata[1].value1 }}</div>
        <div class="rt-3">{{ (+defaultdata[1].value2 / total * 100).toFixed(2) }}%</div>
      </div>
    </div>
		<div ref="linechart" class="linechart"></div>
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: 'template.scope67',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '柱形图-有问题-scope67',
			timer: null,
			defaultdata: [
				{ value1: '文本一', value2: '6609' },
				{ value1: '文本二', value2: '232' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {

			},
      total: 1,
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
      this.total = 0
      n.forEach((item, i) => {
        if (i < 2) {
          this.total += +item.value2
        }
      })
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.linechart);
      let vdata = JSON.parse(JSON.stringify(this.defaultdata))
      vdata = vdata.slice(0, 2).map(item => {
        return {
          name: item[this.valueMap[0].key],
          value: item[this.valueMap[1].key]
        }
      })
			var Toption = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          data: []
        },
        color: ["#0580ff", "#75fafd"],
        series: [
          {
            // name: "黑白",
            type: "pie",
            label: {
              normal: {
                // show: true,
                color: "transparent",
                position: "outside",
                // formatter: params => {
                //   return params.name;
                // },
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            radius: ["55%", "65%"],
            center: ["50%", "50%"],
            // adjust the start angle
            startAngle: 90,
            data: vdata
          }
        ]
      };
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	created() {

	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
    this.total = 0
    this.defaultdata.forEach((item, i) => {
      if (i < 2) {
        this.total += +item.value2
      }
    })
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
    this.setData()
		this.DrawEcharts(); //需要刷新的数据
	},
}
</script>

<style scoped>
.line {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}

.bg1 {
  width: 195px;
  height: 195px;
  box-sizing: border-box;
  left: calc(50% - 97.5px);
  top: calc(50% - 97.5px);
  background: url("@/assets/temimg2/right-bg.png") no-repeat;
  background-size: 100%;
  position: relative;
  z-index: 1;
}

.bg2 {
  width: 55px;
  height: 44px;
  /* margin: 38px 0 0 40px; */
  position: absolute;
  top: calc(50% - 27.5px);
  left: calc(50% - 22px);
  box-sizing: border-box;
  background: url("@/assets/temimg2/right-center.png") no-repeat;
  background-size: 100%;

  z-index: 10;
}

.textPosition {
  width: 435px;
  height: 240px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 10px 0;
}

.left-text {
  width: 217.5px;
  height: 240px;
  position: absolute;
  top: 0;
  left: 0;
}

.hengg {
  width: 68px;
  height: 4px;
  background: #0C2F65;
  position: relative;
  margin: 16px 0 0 40px;
}

.hengg2 {
  width: 13px;
  height: 4px;
  background: #0D78FA;
  position: absolute;
  left: 0;
}

.lt-1 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 17px;
  margin: 70px 0 0 40px;
}

.lt-2 {
  margin: 16px 0 0 40px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #0D78FA;
  line-height: 17px;
  max-width: 80px;
}

.lt-3 {
  margin: 16px 0 0 40px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 17px;
}


.right-text {
  width: 217.5px;
  height: 240px;
  /* background: lightblue; */
  position: absolute;
  top: 0;
  right: 0;
}

.henggr {
  width: 68px;
  height: 4px;
  background: #2e6970;
  position: relative;
  margin: 16px 0 0 130px;
}

.henggr2 {
  width: 13px;
  height: 4px;
  background: #75fafd;
  position: absolute;
  left: 0;

}

.rt-1 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 17px;
  margin: 70px 0 0 130px;
}

.rt-2 {
  margin: 16px 0 0 130px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #75fafd;
  line-height: 17px;
}

.rt-3 {
  margin: 16px 0 0 130px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 17px;
}


.linechart {
	width: 100%;
	height: 100%;
	position: absolute;
  left: 0;
  top: 10px;
  width: 435px;
  height: 240px;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  padding: 0px;
  margin: 0px;
  border-width: 0px;
  z-index: 99;

}
</style>